import { getOwnerId } from 'legacy/lut/selectors/app'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { REQUEST_INIT_PLAN } from 'partner360/features/landing/constants'
import { initPlan } from 'partner360/services/landing/initPlan'

interface IRequestInitPlanParams {
  partnerId: string
  fYear: number
}
export const requestInitPlan = createAsyncThunk(
  REQUEST_INIT_PLAN,
  async ({ partnerId, fYear }: IRequestInitPlanParams, { getState }) => {
    const ownerId = compose(getOwnerId, getState)()

    return await initPlan({
      ownerId,
      partnerId,
      fYear,
    })
  }
)
